import * as THREE from "three";
import parameterValues from "./parameterValues";

export const simulationUniforms = {
  previousIterationTexture: { value: null },
  resolution: {
    value: new THREE.Vector2(
      parameterValues.canvas.width,
      parameterValues.canvas.height,
    ),
  },
  mousePosition: { value: new THREE.Vector2(-1, -1) },
  brushRadius: { value: 10.0 },
  styleMapTexture: { value: null },
  styleMapResolution: { value: new THREE.Vector2(-1, -1) },
  styleMapTransforms: { value: new THREE.Vector4(1.0, 0.0, 0.0, 0.0) },
  styleMapParameters: {
    value: new THREE.Vector4(
      parameterValues.f,
      parameterValues.k,
      parameterValues.dA,
      parameterValues.dB,
    ),
  },
  bias: {
    value: new THREE.Vector2(parameterValues.bias.x, parameterValues.bias.y),
  },
  f: { value: parameterValues.f },
  k: { value: parameterValues.k },
  dA: { value: parameterValues.dA },
  dB: { value: parameterValues.dB },
  timestep: { value: parameterValues.timestep },
  maskEnabled: { value: parameterValues.mask.enabled ? 1.0 : 0.0 },
};

export const displayUniforms = {
  textureToDisplay: { value: null },
  resolution: simulationUniforms.resolution,
  blurRadius: { value: parameterValues.postProcess.blurRadius },
  chromaticAberration: {
    value: parameterValues.postProcess.chromaticAberration,
  },
  bwColorHigh: {
    value: new THREE.Vector3(
      parameterValues.twoToneColors.colorHighRGB.r / 255,
      parameterValues.twoToneColors.colorHighRGB.g / 255,
      parameterValues.twoToneColors.colorHighRGB.b / 255,
    ),
  },
  bwColorLow: {
    value: new THREE.Vector3(
      parameterValues.twoToneColors.colorLowRGB.r / 255,
      parameterValues.twoToneColors.colorLowRGB.g / 255,
      parameterValues.twoToneColors.colorLowRGB.b / 255,
    ),
  },
  bwThreshold: { value: 0.4 },
};

export const passthroughUniforms = {
  textureToDisplay: { value: null },
};
